export enum UploadStatus {
  CLIPPING = 'clipping',
  SUCCEEDED = 'succeess',
  FAILED = 'failure',
  IMPORTING = 'importing',
  UPLOADED = 'uploaded',
  UPLOADING = 'uploading',
}
